import { render, staticRenderFns } from "./TSMath.vue?vue&type=template&id=4dcc4bf8&scoped=true&"
import script from "./TSMath.vue?vue&type=script&lang=js&"
export * from "./TSMath.vue?vue&type=script&lang=js&"
import style0 from "./TSMath.vue?vue&type=style&index=0&id=4dcc4bf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc4bf8",
  null
  
)

export default component.exports